import mustache from 'mustache';

export default class Base {
    constructor(id, params = {}, result = {}, options = {}) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
    }

    async query(data) {
        // console.log('base.js -> query')
        this.showPreloader()
        let resultData = undefined,
            obDefaultPostData = {
                [this.params.ACTION_VARIABLE]: 'recalculateAjax',
                via_ajax: 'Y',
                site_id: BX.message('SITE_ID'),
                site_template_id: this.options.siteTemplateId,
                sessid: BX.bitrix_sessid(),
                template: this.options.template,
                signedParamsString: this.options.signedParamsString
            },
            postData = Object.assign({}, data, obDefaultPostData)
        // console.log('base.js -> this.options.ajaxUrl =', this.options.ajaxUrl)
        // console.log('base.js -> postData =', postData)
        resultData = await Endorphine.Api.query(this.options.ajaxUrl, postData)
        this.hidePreloader()
        return resultData
    }

    renderMustache(templateId, targetId, data) {
        let mixId = `${templateId}_${targetId}`, templateHtml = null, $target = null
        if (this.hasOwnProperty('mustacheCache') == false) {
            this.mustacheCache = {}
        }
        if (this.mustacheCache.hasOwnProperty(mixId)) {
            templateHtml = this.mustacheCache[mixId].templateHtml
            $target = this.mustacheCache[mixId].$target
        } else {
            let $template = document.getElementById(templateId)
            $target = document.getElementById(targetId)
            if (!$template || !$target) {
                return
            }
            templateHtml = $template.innerHTML
            this.mustacheCache[mixId] = {templateHtml: templateHtml, $target: $target}
        }
        let rendered = mustache.render(templateHtml, data)
        $target.innerHTML = rendered
    }

    showPreloader() {
        this.$component.classList.add('is-loading')
        // BX.showWait(BX(this.id))
    }

    hidePreloader() {
        this.$component.classList.remove('is-loading')
        // BX.closeWait(BX(this.id))
    }

    get $component() {
        return document.getElementById(this.id)
    }
}
